var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prism-editor',_vm._b({staticClass:"prism-editor",attrs:{"highlight":_vm.highlighter},model:{value:(_vm.valueComp),callback:function ($$v) {_vm.valueComp=$$v},expression:"valueComp"}},'prism-editor',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }